import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/centered-icon.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/centered-icon.css');

export const CenteredIconDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      We can use the same properties as in the Centered Prompt example to center
      other content, such as icons. In this example, the icon is centered inside
      of the circle.
    </p>
  </DemoPage>
);

CenteredIconDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/CenteredIconDemo.js